export const environment = {
  production: false,
  mapboxToken: 'pk.eyJ1Ijoid2dzLXN3IiwiYSI6ImNtbTBsaGtvYTAxcWIycHNiMHE3dzJydmUifQ.x0DeHK83ll6505gi4xKfrg',
  apiUrl: 'https://services.ansiao.wegoshare.com/v3'
};
